export default __webpack_public_path__ + "static/media/8.ec5e9630.png";